import { cn } from "@/lib/utils";

// Color family derived from the top-level Stripe event prefix
// e.g. "payment_intent.succeeded" → "payment_intent"
const TYPE_FAMILY_CLASSES: Record<string, string> = {
  payment_intent: "bg-green-100 text-green-700",
  charge: "bg-green-100 text-green-700",
  customer: "bg-blue-100 text-blue-700",
  subscription: "bg-indigo-100 text-indigo-700",
  invoice: "bg-indigo-100 text-indigo-700",
  payout: "bg-yellow-100 text-yellow-700",
  account: "bg-orange-100 text-orange-700",
  capability: "bg-orange-100 text-orange-700",
  person: "bg-purple-100 text-purple-700",
  transfer: "bg-teal-100 text-teal-700",
  refund: "bg-red-100 text-red-700",
  dispute: "bg-red-100 text-red-700",
  radar: "bg-red-100 text-red-700",
  terminal: "bg-muted text-muted-foreground",
  identity: "bg-pink-100 text-pink-700",
};

function eventFamily(type: string): string {
  const prefix = type.split(".")[0] ?? "";
  // eslint-disable-next-line security/detect-object-injection -- controlled lookup from Stripe event type prefix
  return TYPE_FAMILY_CLASSES[prefix] ?? "bg-muted text-muted-foreground";
}

interface EventTypeBadgeProps {
  type: string;
  className?: string;
}

export function EventTypeBadge({ type, className }: EventTypeBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 font-mono text-xs font-medium",
        eventFamily(type),
        className,
      )}
      title={type}
    >
      {type}
    </span>
  );
}
